import { DialogContentText } from "@material-ui/core";
import ActionDialog from "@saleor/components/ActionDialog";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

export interface SubscriberDeleteDialgProps {
  confirmButtonState: ConfirmButtonTransitionState;
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
  title: string;
}
const SubscriberDeleteDialg: React.FC<SubscriberDeleteDialgProps> = ({
  title,
  confirmButtonState,
  onClose,
  onConfirm,
  open
}) => {
  const intl = useIntl();
  return (
    <ActionDialog
      open={open}
      onClose={onClose}
      confirmButtonState={confirmButtonState}
      onConfirm={onConfirm}
      variant="delete"
      title={intl.formatMessage({
        defaultMessage: "Delete subscriber",
        description: "dialog email"
      })}
    >
      <DialogContentText>
        <FormattedMessage
          defaultMessage="Are you sure you want to delete {subscriber}?"
          description="dialog content"
          values={{
            subscriber: <strong>{title}</strong>
          }}
        />
      </DialogContentText>
    </ActionDialog>
  );
};
export default SubscriberDeleteDialg;
